const FAVORITES_STORAGE_KEY = 'partiu-quadra-favorites-v1'

type FavoritesByUser = Record<string, string[]>

function parseFavorites(raw: string | null): FavoritesByUser {
  if (!raw) {
    return {}
  }

  try {
    const parsed: unknown = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return {}
    }

    return Object.fromEntries(
      Object.entries(parsed as Record<string, unknown>).map(([userKey, favorites]) => {
        if (!Array.isArray(favorites)) {
          return [userKey, []]
        }

        const sanitized = Array.from(
          new Set(
            favorites.filter(
              (value): value is string => typeof value === 'string' && value.length > 0,
            ),
          ),
        )

        return [userKey, sanitized]
      }),
    )
  } catch {
    return {}
  }
}

export function loadFavoritesByUser(): FavoritesByUser {
  if (typeof window === 'undefined') {
    return {}
  }

  return parseFavorites(window.localStorage.getItem(FAVORITES_STORAGE_KEY))
}

export function saveFavoritesByUser(favoritesByUser: FavoritesByUser): void {
  if (typeof window === 'undefined') {
    return
  }

  window.localStorage.setItem(FAVORITES_STORAGE_KEY, JSON.stringify(favoritesByUser))
}
